import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Loader, Dimmer } from 'semantic-ui-react';
import moment from 'moment';
import axios from 'axios';
import { validaSoloNumero } from '../util/varios';
import { Mensaje, MensajeSiNo } from '../components/mensajes';
import CatalogoCliente from './catalogoCliente';
import CatalogoPersona from './catalogoPersona';


const RegistrarClientes = (props) => {

    let op = require('../../public/modulos/datos');
    let token = sessionStorage.getItem('jwtToken');
    let anio = JSON.parse(sessionStorage.getItem('anioactu'));
    const fechaTope = moment(JSON.parse(sessionStorage.getItem('fechasistema'))).format('YYYY-MM-DD').replace(anio.toString(), (anio - 18).toString());
    let registrado = false;
    let muni = '';
    let ciu = '';
    let valrif = 0;

    const btnCancela = useRef();
    const btnAcepta = useRef();
    const chkNatural = useRef();
    const chkJuridico = useRef();
    const txtId = useRef();
    const cmbRif = useRef();
    const txtRif = useRef();
    const txtRazon = useRef();
    const txtDirClient = useRef();
    const txtEmailClient = useRef();
    const txtTlf1Client = useRef();
    const txtTlf2Client = useRef();
    const txtEstado = useRef();
    const txtMunicipio = useRef();
    const txtCiudad = useRef();
    const txtStatus = useRef();
    const txtGrupoCLiente = useRef();
    const txtIrsl = useRef();
    const txtRetencion = useRef();

    const cmbNacionalidad = useRef();
    const txtCedRes = useRef();
    const cmbSexo = useRef();
    const txtFechaNac = useRef();
    const txtNomResp = useRef();
    const txtApeResp = useRef();
    const txtDireccion = useRef();
    const txtEmail = useRef();
    const txtTlf1 = useRef();
    const txtTlf2 = useRef();


    const [body, setBody] = useState(null);
    const [visibleBtn, setVisibleBtn] = useState('visible');
    const [ops, setOps] = useState(0);
    const [tituloHeader, setTituloHeader] = useState('Gestionar Proveedores.');
    const [catalogoPersona, setCatalogoPersona] = useState(false);
    const [operacionPer, setOperacionPer] = useState(0);
    const [activob, setActivob] = useState(true);
    const [estados, setEstados] = useState([]);
    const [municipios, setMunicipios] = useState([]);
    const [nacnalidad, setNacnalidad] = useState();
    const [ciudades, setCiudades] = useState([]);
    const [catalogoCliente, setCatalogoCliente] = useState(false);
    const [habilitado, setHabilitado] = useState(true);
    const [habilitadoNU, setHabilitadoNU] = useState(true);
    const [select, setSelect] = useState(1);
    const [activo, setActivo] = useState(true);
    const [activate, setActivate] = useState(false);
    const [botones, setBotones] = useState({
        incluir: false,
        consultar: false,
        modificar: false,
        eliminar: false,
        aceptar: true,
        cancelar: true,
        catalogo: true,
        catalogoper: true
    });
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });

    const seleccionarRegistros = () => {

        let campos = '*';
        let nomtab = 'estado';
        let orden = 'idestado';

        let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

        setActivate(true);

        axios.get(endpoint, {
            headers: {
                'x-access-token': `${token}`
            }
        }).then(function (response) {

            if (response.status === 200) {
                if (response.data.length > 0) {
                    setEstados(response.data);
                }
            }


        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);

        }).finally(() => {
            setActivate(false);
        })

    }


    const selectMunicipios = (id) => {
        let campos = '*';
        let nomtab = 'municipio';
        let nomid = 'idestado';
        let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

        axios.get(endpoint, {
            headers: {
                'x-access-token': `${token}`
            }
        }).then(function (response) {
            if (response.status === 200) {
                setMunicipios(response.data);
                if (registrado || !botones.consultar || !botones.modificar || !botones.eliminar) {
                    txtMunicipio.current.value = muni;
                }

            }
        }).catch(function (error) {
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
        })
    };

    const selectCiudad = (id) => {
        let campos = '*';
        let nomtab = 'ciudad';
        let nomid = 'idmunicipio';
        let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;
        axios.get(endpoint, {
            headers: {
                'x-access-token': `${token}`
            }
        }).then(function (response) {
            if (response.status === 200) {
                setCiudades(response.data);
                if (registrado || !botones.consultar || !botones.modificar || !botones.eliminar) {
                    txtCiudad.current.value = ciu;
                }
            }
        }).catch(function (error) {
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
        })
    };


    const blanquear = () => {
        setTituloHeader('Gestionar Proveedores.')

        setVisibleBtn('visible')
        setActivate(false);
        setActivo(true);
        setActivob(true);
        setBody(null);
        setOperacionPer(0);
        setHabilitado(true);
        setHabilitadoNU(true);
        setMunicipios([]);
        setCiudades([]);
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
        setBotones({
            incluir: false,
            consultar: false,
            modificar: false,
            eliminar: false,
            aceptar: true,
            cancelar: true,
            catalogo: true,
            catalogoper: true
        });
        chkJuridico.current.checked = true;
        cmbRif.current.value = '';
        txtRif.current.value = '';
        txtId.current.value = 0;
        txtRazon.current.value = '';
        txtDirClient.current.value = '';
        txtTlf1Client.current.value = '';
        txtTlf2Client.current.value = '';
        txtEmailClient.current.value = '';
        txtStatus.current.value = '';
        txtEstado.current.value = '';
        txtMunicipio.current.value = '';
        txtCiudad.current.value = '';

        cmbNacionalidad.current.value = '';
        txtCedRes.current.value = '';
        cmbSexo.current.value = '';
        txtFechaNac.current.value = '';
        txtNomResp.current.value = '';
        txtApeResp.current.value = '';
        txtDireccion.current.value = '';
        txtEmail.current.value = '';
        txtTlf1.current.value = '';
        txtTlf2.current.value = '';

        setSelect(1);
        setNacnalidad();

    }

    const onChangeValidar = () => {

        let sigue = true;
        if (ops === 1) {

            let nom;
            nom = select === 1 ? 'Nombre/Razón Social' : 'Nombres y Apellidos';

            let ced;
            ced = select === 1 ? 'R.I.F' : 'Cédula';

            if (txtStatus.current.value === '') {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Seleccione el Estatus del Cliente', icono: 'informacion' });
                txtStatus.current.focus()
                sigue = false
            } else if (txtRazon.current.value === '') {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El campo' + ' ' + nom + ' ' + 'no debe ir Vacio', icono: 'informacion' });
                txtRazon.current.focus()
                sigue = false
            } else if (txtDirClient.current.value === '') {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Describa la Dirección del Cliente', icono: 'informacion' });
                txtDirClient.current.focus()
                sigue = false
            } else if (txtEmailClient.current.value === '') {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Describa el Correo del Cliente', icono: 'informacion' });
                txtEmailClient.current.focus()
                sigue = false
            } else if (txtEstado.current.value === '') {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Seleccione el Estado del Cliente', icono: 'informacion' });
                txtEstado.current.focus()
                sigue = false
            } else if (txtMunicipio.current.value === '') {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Seleccione el Municipio del Cliente', icono: 'informacion' });
                txtMunicipio.current.focus()
                sigue = false
            } else if (txtCiudad.current.value === '') {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Seleccione la Ciudad del Cliente', icono: 'informacion' });
                txtCiudad.current.focus()
                sigue = false
            } else if (txtCedRes.current.value === '') {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Seleccionar el Responsable', icono: 'informacion' });
                txtCedRes.current.focus()
                sigue = false
            } else if (txtGrupoCLiente.current.value === '') {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Seleccione el Tipo de Grupo del Cliente', icono: 'informacion' });
                txtGrupoCLiente.current.focus()
                sigue = false
            }
        }


        if (sigue) {

            var cliente = [];
            var repre = [];
            cliente.push({
                idagente: !botones.incluir ? 0 : txtId.current.value,
                nombre: txtRazon.current.value.trim(),
                direccion: txtDirClient.current.value.trim(),
                tipoper: chkNatural.current.checked ? 0 : 1,
                rif: nacnalidad + txtRif.current.value,
                reprelegal: cmbNacionalidad.current.value + txtCedRes.current.value,
                telefono: txtTlf1Client.current.value,
                celular: txtTlf2Client.current.value,
                email: txtEmailClient.current.value.trim(),
                cliente: true,
                statuscliente: txtStatus.current.value.trim(),
                estado: txtEstado.current.value.trim(),
                municipio: txtMunicipio.current.value.trim(),
                ciudad: txtCiudad.current.value.trim(),
                islr: txtIrsl.current.value.trim(),
                grupcli: txtGrupoCLiente.current.value.trim(),
                agenteretencion: txtRetencion.current.checked ? true : false
            })
            repre.push({
                cedula: parseInt(txtCedRes.current.value),
                correoe: txtEmail.current.value.trim(),
                tlf1: txtTlf1.current.value.trim(),
                tlf2: txtTlf2.current.value.trim(),
                apellidos: txtApeResp.current.value.trim(),
                direccion: txtDireccion.current.value.trim(),
                fnacimiento: txtFechaNac.current.value.trim(),
                nacionalidad: cmbNacionalidad.current.value.trim(),
                nombres: txtNomResp.current.value.trim(),
                sexo: cmbSexo.current.value.trim()
            })

            setBody({
                operacionper: operacionPer,
                agente: cliente,
                repre: repre,
                client: []
            });


            let msg = '';
            if (!botones.incluir) {
                msg = 'Esta Seguro de Registrar estos Datos.';
            } else if (!botones.modificar) {
                msg = 'Esta Seguro de Modificar estos Datos.';
            } else if (!botones.eliminar) {
                msg = 'Esta Seguro de Eliminar estos Datos.';
            }

            setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });
        }
    }

    const procesarRegistro = () => {
        setActivate(true);
        let endpoint = `${op.conexion}/api/agente/actualizar/${ops}`;
        axios.post(endpoint, body, {
            headers: {
                'x-access-token': `${token}`
            }
        }).then(function (response) {
            if (response.status === 200) {
                
                setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Registro Creado Correctamente', icono: 'exito' });

                setActivate(false);
            }
        }).catch(function (error) {
            let mensaje = '';
            if (error.response === undefined) {
                mensaje = 'Error de Conexion'
            } else {
                if (error.response.data.message === 'duplicate key value violates unique constraint "agente_rif_key"') {
                    mensaje = 'Ya existe un Registro con este rif'

                } else if (error.response.data.message === 'duplicate key value violates unique constraint "agente_email_key"') {
                    mensaje = 'Ya existe un Registro con este correo'
                }
                else {
                    mensaje = error.response.data.message
                }
            }
            setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
            setActivate(false);
        })
    };

    const handleCloseSi = () => {
        setActivate(false);
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
        procesarRegistro();

    };

    const handleInputNumChange = (event) => {
        event.preventDefault();
        validaSoloNumero(event);

        if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;
    };

    const datosRes = () => {
        let campos = '*';
        let nomtab = 'persona';
        let nomid = 'cedula';
        let nomid2 = 'nacionalidad';
        let id = txtCedRes.current.value;
        let id2 = cmbNacionalidad.current.value;
        let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=${id2}`;

        setActivate(true);
        axios.get(endpoint, {
            headers: {
                'x-access-token': `${token}`
            }
        }).then(function (response) {
            if (response.status === 200) {

                cmbSexo.current.value = ''
                txtFechaNac.current.value = ''
                txtNomResp.current.value = ''
                txtApeResp.current.value = ''
                txtDireccion.current.value = ''
                txtEmail.current.value = ''
                txtTlf1.current.value = ''
                txtTlf2.current.value = ''

                if (response.data !== '') {
                    setHabilitadoNU(true);
                    setOperacionPer(0);
                    cmbSexo.current.value = response.data.sexo
                    txtFechaNac.current.value = moment(response.data.fnacimiento).format('YYYY-MM-DD')
                    txtNomResp.current.value = response.data.nombres
                    txtApeResp.current.value = response.data.apellidos
                    txtDireccion.current.value = response.data.direccion
                    txtEmail.current.value = response.data.correoe
                    txtTlf1.current.value = response.data.tlf1
                    txtTlf2.current.value = response.data.tlf2
                    if (!botones.consultar) {
                        btnCancela.current.focus();
                    } else {
                        btnAcepta.current.focus();
                    }

                } else {
                    txtNomResp.current.focus();
                    setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No existe una persona con este N° de Cédula/RIF', icono: 'informacion' });
                    setOperacionPer(1);
                    setHabilitadoNU(false);

                }
            }
            setActivate(false);
        }).catch(function (error) {
            setActivate(false);
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
        })
    };

    const datosPro = (rif) => {

        let campos = '*';
        let nomtab = 'agente';
        let nomid = 'rif';
        let id = rif;
        let endpoint = '';

        endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

        setActivate(true);

        axios.get(endpoint, {
            headers: {
                'x-access-token': `${token}`
            }
        }).then(function (response) {

            if (response.status == 200) {

                if (response.data !== '') {

                    if (response.data.cliente && response.data.rif === valrif) {

                        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡El Cliente con el N° de Cédula o RIF' + ' ' + response.data.rif + ' ' + 'ya Existe!', icono: 'informacion' });
                        setOps(2);
                        txtId.current.value = '';
                        txtStatus.current.value = '';
                        txtRazon.current.value = '';
                        txtDirClient.current.value = '';
                        txtEmailClient.current.value = '';
                        txtTlf1Client.current.value = '';
                        txtTlf2Client.current.value = '';
                        txtEstado.current.value = '';
                        txtMunicipio.current.value = '';
                        txtCiudad.current.value = '';
                        txtRif.current.value = '';
                        cmbRif.current.value = '--';

                        cmbNacionalidad.current.value = '';
                        txtCedRes.current.value = '';

                        muni = '';
                        ciu = '';

                        cmbSexo.current.value = ''
                        txtFechaNac.current.value = ''
                        txtNomResp.current.value = ''
                        txtApeResp.current.value = ''
                        txtDireccion.current.value = ''
                        txtEmail.current.value = ''
                        txtTlf1.current.value = ''
                        txtTlf2.current.value = ''

                    } else if (!response.data.cliente) {
                        txtId.current.value = response.data.idagente;
                        txtStatus.current.value = response.data.statuscliente;
                        txtRazon.current.value = response.data.nombre;
                        txtDirClient.current.value = response.data.direccion;
                        txtEmailClient.current.value = response.data.email;
                        txtTlf1Client.current.value = response.data.telefono;
                        txtTlf2Client.current.value = response.data.celular;
                        txtEstado.current.value = response.data.estado;
                        txtMunicipio.current.value = response.data.municipio;
                        txtCiudad.current.value = response.data.ciudad;

                        cmbNacionalidad.current.value = response.data.reprelegal.substring(0, 1);
                        txtCedRes.current.value = response.data.reprelegal.substring(1, 9);

                        muni = response.data.municipio.trim();
                        ciu = response.data.ciudad.trim();

                        selectMunicipios(response.data.estado.trim());
                        selectCiudad(response.data.municipio.trim());
                        datosRes();
                        setNacnalidad(response.data.rif.substring(0, 1));

                        let tip = response.data.tipoper;
                        if (tip === 1) {
                            chkJuridico.current.checked = true;
                            chkNatural.current.checked = false;
                        } else {
                            chkNatural.current.checked = true;
                            chkJuridico.current.checked = false;
                        }

                        setSelect(response.data.tipoper);
                    }

                } else {

                    txtRazon.current.focus();

                }
            }

            setActivate(false);

        }).catch(function (error) {

            setActivate(false);
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });

        })

    }

    const validarPersona = (event) => {
        event.preventDefault();
        validaSoloNumero(event);
        if (event.which === 13 || typeof (event.which) === 'undefined') {
            if (event.target.value !== '') {
                if (cmbNacionalidad.current.value !== '') {
                    datosRes();
                } else {
                    setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'debe seleccionar la nacionalidad', icono: 'informacion' });
                    cmbNacionalidad.current.focus();
                }

            } else {
                cmbNacionalidad.current.value = ''
                cmbSexo.current.value = ''
                txtFechaNac.current.value = ''
                txtNomResp.current.value = ''
                txtApeResp.current.value = ''
                txtDireccion.current.value = ''
                txtEmail.current.value = ''
                txtTlf1.current.value = ''
                txtTlf2.current.value = ''
                setHabilitadoNU(true);
            }
        }
    };

    const validarCliente = (event) => {
        event.preventDefault();
        if (event.which === 13 || typeof (event.which) === 'undefined') {
            if (event.target.value !== '') {
                if (cmbRif.current.value !== "") {
                    datosPro(nacnalidad + event.target.value);
                } else {
                    setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Seleccionar el Tipo de Nacionalidad', icono: 'informacion' });
                    cmbRif.current.focus();
                }

            }
        }
    };

    const cancelar = () => {
        blanquear();
        props.onHideCancelar();
    }

    const onChangeCliente = (e) => {

        let n;
        let r;

        if (e.target.name === 'estado') {
            setMunicipios([]);
            setCiudades([]);
            if (e.target.value !== '') {
                selectMunicipios(e.target.value);
            }

        } else if (e.target.name === 'municipio') {
            setCiudades([]);
            if (e.target.value !== '') {
                selectCiudad(e.target.value);
            }

        } else if (e.target.name === 'tipoper') {
            if (chkNatural.current.checked) {
                setSelect(0)
            } else if (chkJuridico.current.checked) {
                setSelect(1);
            }
        } else if (e.target.name === 'cmbrif') {
            let nac = cmbRif.current.value;
            txtRif.current.value = '';
            setNacnalidad(nac);
        } else if (e.target.name === 'cedula') {
            n = cmbRif.current.value;
            r = txtRif.current.value;
        }
        valrif = n + r;
    }

    const onChange = (e) => {

        if (e.target.name === 'correoe' || e.target.name === 'apellidos' || e.target.name === 'direccion'
            || e.target.name === 'nombres' || e.target.name === 'descripcion') {
            e.target.value = e.target.value.toUpperCase();
        } else if (e.target.name === 'nacionalidad' && txtCedRes.current.value !== '') {
            if (e.target.value !== '') {
                datosRes();
            } else {
                txtCedRes.current.value = '';
                cmbSexo.current.value = '';
                txtFechaNac.current.value = '';
                txtNomResp.current.value = '';
                txtApeResp.current.value = '';
                txtDireccion.current.value = '';
                txtEmail.current.value = '';
                txtTlf1.current.value = '';
                txtTlf2.current.value = '';
            }
        }
    }

    const onCatalogoCliente = (values) => {
        setCatalogoCliente(false);

        txtRazon.current.value = values.nombre;
        cmbRif.current.value = values.rif.substring(0, 1);
        txtRif.current.value = values.rifs;
        cmbNacionalidad.current.value = values.reprelegal.substring(0, 1);
        txtCedRes.current.value = values.repre;
        setNacnalidad(values.rif.substring(0, 1));
        datosPro(values.rif);
        if (!botones.modificar) {
            setBotones({ ...botones, catalogoper: false });
        }
    }

    const onCatalogoPersona = (cedPer, nomPer, apePer, correoPer, tlf1Per,
        tlf2Per, fnacPer, nacPer, sexoPer, direPer) => {
        setCatalogoPersona(false);
        setHabilitadoNU(true);
        setOperacionPer(0);
        cmbNacionalidad.current.value = nacPer;
        txtCedRes.current.value = cedPer;
        cmbSexo.current.value = sexoPer;
        txtFechaNac.current.value = moment(fnacPer).format('YYYY-MM-DD');
        txtNomResp.current.value = nomPer;
        txtApeResp.current.value = apePer;
        txtDireccion.current.value = direPer;
        txtEmail.current.value = correoPer;
        txtTlf1.current.value = tlf1Per;
        txtTlf2.current.value = tlf2Per;
    }

    useEffect(() => {
        seleccionarRegistros();
    }, []);

    const cerrarModal = () => {
        props.onHideCancelar();
        blanquear();
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
    }

    return (
        <Modal
            {...props}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            size="xl"
            backdrop="static"
            keyboard={false}
            onShow={() => {
                setOps(props.op);
            }}
        >
            <Modal.Header className='azulGradiant2 header-modal'>
                <div className="fw-bold text-light"><h3>Registrar Cliente</h3></div>
                <button ref={btnCancela} className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body>

                <div className="row col-md-12">
                    <div className='col-md-12'>
                        <fieldset className=' row col-sm-12 mx-auto border-azul rounded'>
                            <legend className="float-none w-auto fw-bold m-0" style={{ fontSize: '15px' }}>Datos del Cliente</legend>
                            <input ref={txtId} autoComplete='off' type="hidden" className="form-control" name='idagente' aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />

                            <div className='col-md-3 mb-3'>
                                <div className="input-group input-group-sm">
                                    <label className="input-group-text" id="inputGroup-sizing-sm">{select === 1 ? "R.I.F" : "Cédula"} </label>

                                    {select === 1 ? <select disabled={ops === 1 ? false : true} ref={cmbRif} name="cmbrif" onChange={onChangeCliente} value={nacnalidad} className="col-sm-3 form-select form-control-sm" >
                                        <option value="">-</option>
                                        <option key="0" value="V">V</option>
                                        <option key="1" value="J">J</option>
                                        <option key="2" value="G">G</option>
                                        <option key="3" value="P">P</option>
                                    </select> : <select disabled={ops === 1 ? false : true} ref={cmbRif} name="cmbrif" onChange={onChangeCliente} value={nacnalidad} className="col-sm-3 form-select form-control-sm" >
                                        <option value="">-</option>
                                        <option key="0" value="V">V</option>
                                        <option key="1" value="E">E</option>
                                    </select>}


                                    <input ref={txtRif} onChangeCapture={onChangeCliente} autoComplete='off' maxLength={9} type="text" disabled={ops === 1 ? false : true} className="form-control col-4 px-1" name='cedula' aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" onKeyUp={validarCliente} onBlur={validarCliente} onChange={onChange} />
                                    {/* <button disabled={ops === 1 ? false : true} type="button" onClick={() => setCatalogoCliente(true)} className="btn btn-success"><i className="fas fa-search"></i></button> */}
                                </div>
                            </div>

                            <div className='col-md-3 mt-15m mx-auto'>
                                <fieldset className='row col-sm-12 mx-auto border-azul rounded mb-1'>
                                    <legend className="float-none m-0 w-auto" style={{ fontSize: '14px' }}>Tipo Persona:</legend>

                                    <div className='col-5 ml-auto'>
                                        <div className="form-check">
                                            <input className="form-check-input" disabled={ops === 1 ? false : true} name="tipoper" value="1" ref={chkNatural} onChange={onChangeCliente} id="tipoper" type="radio" />
                                            <label className="form-check-label" for="exampleRadi4">
                                                Natural
                                            </label>
                                        </div>
                                    </div>

                                    <div className='col-5 ml-auto'>
                                        <div className="form-check">
                                            <input className="form-check-input" disabled={ops === 1 ? false : true} name="tipoper" value="2" ref={chkJuridico} onChange={onChangeCliente} id="tipoper" defaultChecked={true} type="radio" />
                                            <label className="form-check-label" for="exampleRadi5">
                                                Juridico
                                            </label>
                                        </div>
                                    </div>

                                </fieldset>
                            </div>

                            <div className='col-md-2 ml-auto'>
                                <div className="input-group input-group-sm">
                                    <label className="input-group-text" id="inputGroup-sizing-sm">Estatus:</label>
                                    <select ref={txtStatus} disabled={ops === 1 ? false : true} className="form-select form-select-sm" aria-label=".form-select-sm example">
                                        <option value="">Seleccione</option>
                                        <option value="51">Activo</option>
                                        <option value="52">Inactivo</option>
                                    </select>
                                </div>
                            </div>

                            <div className="input-group input-group-sm mb-2 col-md-12 py-1">
                                <label className="input-group-text" id="inputGroup-sizing-sm">{select === 1 ? "Nombre/Razón Social" : "Nombres y Apellidos"}</label>
                                <input type="text" autoComplete='off' ref={txtRazon} disabled={ops === 1 ? false : true} name='nombres' className="form-control" onChange={onChange} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                            </div>

                            <div className="input-group input-group-sm mb-2 col-md-12">
                                <label className="input-group-text" id="inputGroup-sizing-sm">Dirección:</label>
                                <textarea type="area" autoComplete='off' ref={txtDirClient} disabled={ops === 1 ? false : true} name='direccion' className="form-control" onChange={onChange} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" style={{ height: 40 }} />
                            </div>
                            <div className="input-group input-group-sm mb-2 col-md-4">
                                <label className="input-group-text" id="inputGroup-sizing-sm">Email:</label>
                                <input type="text" autoComplete='off' ref={txtEmailClient} disabled={ops === 1 ? false : true} className="form-control" name='correoe' aria-label="Sizing example input" onChange={onChange} aria-describedby="inputGroup-sizing-sm" />
                            </div>
                            <div className="input-group input-group-sm mb-2 col-md-4">
                                <label className="input-group-text" id="inputGroup-sizing-sm">Telefono:</label>
                                <input type="text" autoComplete='off' maxLength={12} ref={txtTlf1Client} disabled={ops === 1 ? false : true} className="form-control" name='tlf1' aria-label="Sizing example input" onChange={onChange} aria-describedby="inputGroup-sizing-sm" onKeyUp={handleInputNumChange} />
                            </div>
                            <div className="input-group input-group-sm mb-2 col-md-4">
                                <label className="input-group-text" id="inputGroup-sizing-sm">Celular:</label>
                                <input type="text" autoComplete='off' maxLength={12} ref={txtTlf2Client} disabled={ops === 1 ? false : true} className="form-control" name='tlf2' aria-label="Sizing example input" onChange={onChange} aria-describedby="inputGroup-sizing-sm" onKeyUp={handleInputNumChange} />
                            </div>

                            <div className="input-group input-group-sm mb-2 col-md-4">
                                <label className="input-group-text" id="inputGroup-sizing-sm">Estado:</label>
                                <select ref={txtEstado} disabled={ops === 1 ? false : true} onChange={onChangeCliente} name='estado' idciudad='estado' className="form-select form-select-sm" aria-label=".form-select-sm example">
                                    <option value="">seleccione</option>
                                    {
                                        estados && estados.map((item, index) => (
                                            <option key={index} value={item.idestado}>{item.nombre}</option>
                                        ))
                                    }
                                </select>
                            </div>

                            <div className="input-group input-group-sm mb-2 col-md-4">
                                <label className="input-group-text" id="inputGroup-sizing-sm">Municipio:</label>
                                <select ref={txtMunicipio} disabled={ops === 1 ? false : true} onChange={onChangeCliente} name='municipio' id='municipio' className="form-select form-select-sm" aria-label=".form-select-sm example">
                                    <option value="">seleccione</option>
                                    {
                                        municipios && municipios.map((item, index) => (
                                            <option key={index} value={item.idmunicipio}>{item.nombre}</option>
                                        ))
                                    }

                                </select>
                            </div>

                            <div className="input-group input-group-sm mb-2 col-md-4">
                                <label className="input-group-text" id="inputGroup-sizing-sm">Ciudad:</label>
                                <select ref={txtCiudad} disabled={ops === 1 ? false : true} name='ciudad' id='ciudad' className="form-select form-select-sm" aria-label=".form-select-sm example">
                                    <option value="">seleccione</option>
                                    {
                                        ciudades && ciudades.map((item, index) => (
                                            <option key={index} value={item.idciudad}>{item.nombre}</option>
                                        ))
                                    }
                                </select>
                            </div>


                        </fieldset>
                    </div>
                    <div className='col-md-12'>
                        <fieldset className=' row col-sm-12 mx-auto border-azul rounded dlflex justify-content-between'>
                            <legend className="float-none w-auto fw-bold" style={{ fontSize: '15px' }}>Responsable</legend>

                            <div className="input-group input-group-sm mb-2 col-md-3">
                                <label className="input-group-text" id="inputGroup-sizing-sm">Cedula:</label>
                                <select ref={cmbNacionalidad} name="nacionalidad" className="form-select form-select-sm col-md-3" disabled={ops === 1 ? false : true} aria-label=".form-select-sm example" onChange={onChange} >
                                    <option value="">--</option>
                                    <option value="V">V</option>
                                    <option value="E">E</option>
                                </select>
                                <input ref={txtCedRes} maxLength={8} autoComplete='off' type="text" disabled={ops === 1 ? false : true} className="form-control col-4 px-1" name='cedula' aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" onKeyUp={validarPersona} onBlur={validarPersona} onChange={onChange} />
                                <button disabled={ops === 1 ? false : true} type="button" onClick={() => setCatalogoPersona(true)} className="btn btn-success"><i className="fas fa-search"></i></button>
                            </div>

                            <div className='col-md-2'></div>
                            <div className="input-group input-group-sm mb-2 col-md-2">
                                <label className="input-group-text" id="inputGroup-sizing-sm">Sexo:</label>
                                <select ref={cmbSexo} className="form-select form-select-sm col-5" name='sexo' disabled={habilitadoNU} onChange={onChange} aria-label=".form-select-sm example">
                                    <option value="">--</option>
                                    <option value="M">M</option>
                                    <option value="F">F</option>
                                </select>
                            </div>
                            <div className="input-group input-group-sm mb-2 col-md-3 ml-auto">
                                <label className="input-group-text" id="inputGroup-sizing-sm">Fecha de Nacimiento</label>
                                <input type="date" ref={txtFechaNac} max={fechaTope} className="form-control" name='fnacimiento' aria-label="Sizing example input" onChange={onChange} disabled={habilitadoNU} aria-describedby="inputGroup-sizing-sm" />
                            </div>



                            <div className="input-group input-group-sm mb-2 col-md-6">
                                <label className="input-group-text" id="inputGroup-sizing-sm">Nombres:</label>
                                <input type="text" autoComplete='off' ref={txtNomResp} name='nombres' className="form-control" onChange={onChange} aria-label="Sizing example input" disabled={habilitadoNU} aria-describedby="inputGroup-sizing-sm" />
                            </div>
                            <div className="input-group input-group-sm mb-2 col-md-6">
                                <label className="input-group-text" id="inputGroup-sizing-sm">Apellidos:</label>
                                <input type="text" autoComplete='off' ref={txtApeResp} name='apellidos' className="form-control" onChange={onChange} aria-label="Sizing example input" disabled={habilitadoNU} aria-describedby="inputGroup-sizing-sm" />
                            </div>
                            <div className="input-group input-group-sm mb-2 col-md-12">
                                <label className="input-group-text" id="inputGroup-sizing-sm">Dirección:</label>
                                <textarea type="area" autoComplete='off' ref={txtDireccion} name='direccion' className="form-control" onChange={onChange} aria-label="Sizing example input" disabled={habilitadoNU} aria-describedby="inputGroup-sizing-sm" style={{ height: 40 }} />
                            </div>
                            <div className="input-group input-group-sm mb-2 col-md-4">
                                <label className="input-group-text" id="inputGroup-sizing-sm">Email:</label>
                                <input type="text" autoComplete='off' ref={txtEmail} className="form-control" name='correoe' aria-label="Sizing example input" onChange={onChange} disabled={habilitadoNU} aria-describedby="inputGroup-sizing-sm" />
                            </div>
                            <div className="input-group input-group-sm mb-2 col-md-4">
                                <label className="input-group-text" id="inputGroup-sizing-sm">Telefono:</label>
                                <input type="text" autoComplete='off' maxLength={12} ref={txtTlf1} className="form-control" name='tlf1' aria-label="Sizing example input" onChange={onChange} disabled={habilitadoNU} aria-describedby="inputGroup-sizing-sm" onKeyUp={handleInputNumChange} />
                            </div>
                            <div className="input-group input-group-sm mb-2 col-md-4">
                                <label className="input-group-text" id="inputGroup-sizing-sm">Celular:</label>
                                <input type="text" autoComplete='off' maxLength={12} ref={txtTlf2} className="form-control" name='tlf2' aria-label="Sizing example input" onChange={onChange} disabled={habilitadoNU} aria-describedby="inputGroup-sizing-sm" onKeyUp={handleInputNumChange} />
                            </div>


                        </fieldset>
                    </div>

                    <div className='col-md-12'>
                        <fieldset className=' row col-sm-12 mx-auto border-azul rounded dlflex justify-content-between'>
                            <legend className="float-none w-auto fw-bold" style={{ fontSize: '15px' }}>Otros Datos</legend>

                            <div className="input-group input-group-sm mb-2 col-md-4">
                                <label className="input-group-text" id="inputGroup-sizing-sm">% Retención I.S.L.R:</label>
                                <input type="text" ref={txtIrsl} disabled={ops === 1 ? false : true} className="form-control px-0" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                            </div>

                            <div className="input-group input-group-sm mb-2 col-md-5">
                                <label className="input-group-text" id="inputGroup-sizing-sm">Grupo de Cliente:</label>
                                <select ref={txtGrupoCLiente} disabled={ops === 1 ? false : true} className="form-select form-select-sm" aria-label=".form-select-sm example">
                                    <option value="">seleccione</option>
                                    <option value="1">VIP</option>
                                    <option value="2">REGULAR</option>
                                </select>
                            </div>



                            <div className='col-md-3'>
                                <div className="form-check">
                                    <input ref={txtRetencion} disabled={ops === 1 ? false : true} className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                    <label className="form-check-label" htmlFor="flexCheckDefault">
                                        Agente de Retención
                                    </label>
                                </div>

                            </div>

                        </fieldset>
                    </div>
                </div>

            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-sm btn-success rounded-pill" onClick={onChangeValidar} style={{ margin: "5px" }} ><i className="fas fa-check-circle"> Aceptar</i> </button>
                <button ref={btnCancela} onClick={cancelar} className="btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"> Cancelar</i></button>
            </Modal.Footer>
            <CatalogoCliente
                show={catalogoCliente}
                nomid='cliente'
                onHideCancelar={() => setCatalogoCliente(false)}
                onHideAceptaCatalogo={onCatalogoCliente}
            />
            <CatalogoPersona
                show={catalogoPersona}
                onHideCancelaCatPer={() => setCatalogoPersona(false)}
                onHideAceptaCatPer={onCatalogoPersona}
            />
            <Dimmer active={activate} inverted>
                <Loader inverted>Cargando...</Loader>
            </Dimmer>
            <Mensaje mensaje={mensaje}
                onHide={() => {
                    mensaje.titulo === 'Exito.' ?
                        cerrarModal() :
                        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                }
                } />
            <MensajeSiNo mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
        </Modal>
    );
}
export default RegistrarClientes;


// WEBPACK FOOTER //
// ./src/catalogos/catalogoAgregarClientes.js